import { PropsWithChildren } from 'react';

import { OrganisationInfoProvider } from '@pletly/feature-organisation';
import { PostsProvider } from '%context/Posts';
import { ConnectionsProvider } from '%context/Connections';
import { PremiumProvider } from '%context/Premium';
import { LoggedUserProvider } from '%context/LoggedUser';
import { InvitationsProvider } from '%context/Invitations';
import { ChatsProvider } from '%context/Chats';

export const UserContexts = ({ children }: PropsWithChildren) => {
	return (
		<LoggedUserProvider>
			<OrganisationInfoProvider>
				<PremiumProvider>
					<ChatsProvider>
						<ConnectionsProvider>
							<PostsProvider>
								<InvitationsProvider>{children}</InvitationsProvider>
							</PostsProvider>
						</ConnectionsProvider>
					</ChatsProvider>
				</PremiumProvider>
			</OrganisationInfoProvider>
		</LoggedUserProvider>
	);
};
